import React from 'react';
import { motion } from 'framer-motion';
const timeline = [{
  days: "DÍA 1–7",
  title: "RECUPERAR TU CALMA"
}, {
  days: "DÍA 8–14",
  title: "VOLVER A TI"
}, {
  days: "DÍA 15–21",
  title: "RECONSTRUIR TU VIDA"
}, {
  days: "DÍA 22–30",
  title: "CREAR TU NUEVA DIRECCIÓN"
}];
export function Experience() {
  return <section className="py-24 md:py-32 bg-ink relative" data-id="element-113" data-mp="1tvh9jmzzg915">
      <div className="container mx-auto px-6" data-id="element-114" data-mp="2ri6gmb9jlbtv">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-115" data-mp="2rgvhior1ks93">
          <h2 className="text-3xl md:text-5xl font-serif text-ivory-bright mb-6 uppercase" data-id="element-116" data-mp="2cl61r8cg9bct">
            ¿CÓMO VIVIRÁS EL PROCESO?
          </h2>
        </motion.div>

        <div className="max-w-4xl mx-auto" data-id="element-117" data-mp="16654mzboun4n">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-118" data-mp="11591wp32p70t">
            {timeline.map((item, index) => <motion.div key={index} className="bg-ink-light border border-white/5 p-6 rounded-xl text-center flex flex-col justify-center items-center h-32" initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} data-id="element-119" data-mp="tqklogpkucmi" data-mpi={index}>
                <span className="text-gold text-xs tracking-widest uppercase font-semibold mb-2" data-id="element-120" data-mp="awos58bqbfvt">{item.days}</span>
                <h3 className="font-serif text-lg text-ivory-bright leading-tight" data-id="element-121" data-mp="frb7tnoufulp">{item.title}</h3>
              </motion.div>)}
          </div>

          <motion.div className="mt-16 text-center" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-122" data-mp="60gjmds1ekxm">
            <p className="font-serif text-2xl md:text-3xl text-ivory-bright italic leading-relaxed max-w-2xl mx-auto" data-id="element-123" data-mp="1ynwd95mvb7md">
              "No tienes que cambiar toda tu vida en un día. Solo necesitas comenzar a dar pasos diferentes."
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}